import { Navigate, Outlet, useLocation } from "react-router-dom"
import React from "react"

export default function PrivateOutlet({
    isAllowed,
    children
}) {
    const location = useLocation();
    if (!isAllowed) {
        // return <Navigate to={redirectPath} replace />; ORIGINAL WORKING VERSION
        return <Navigate to={`/login?redirect=${encodeURIComponent(location.pathname + location.search)}`} />;
    }
    return children ? children : <Outlet />;
}
